import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type cmfcCredType = CarrierLogisticsCredType
export const cmfcDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const cmfc: CarrierDef<cmfcCredType> = {
  name: 'C&M Forwarding',
  scac: 'cmfc',
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'pickup', 'profinder', 'tracking'],
  documentTypes: cmfcDocumentTypes,
}
